export const EVENT_TYPES = {
    RUN: 'run',
    CYCLE: 'cycle',
};

export const EVENT_INTERVALS = {
    WEEKLY: 'weekly',
    MONTHLY: 'monthly',
    SINGLE: 'single',
};

export const PREDEFINED_INTERVALS = {
    [EVENT_INTERVALS.WEEKLY]: [
        'Every Monday',
        'Every Tuesday',
        'Every Wednesday',
        'Every Thursday',
        'Every Friday',
        'Every Saturday',
        'Every Sunday',
    ],
    [EVENT_INTERVALS.MONTHLY]: ['First Monday of the month', 'First Saturday of the month', 'First Sunday of the month'],
};
